export const FALLBACK_TAX_RATE = 0.08875;

export const CARD_FEE_RATE = 0.029;
